import "./RoleAssignmentTable.scoped.scss";
import React from "react";
import DeleteIcon from "media/icons/dls/delete.svg";
import "./management/UserDetail.scoped.scss";
import { IManageUserDetail, Roles, UserGroups } from "interfaces/user/UserInterfaces";
import UserGroupIcon from "./management/UserGroupIcon";
import {
  AddRoleAssignmentService
} from "../../services/addRoleAssignmentService";
interface IRoleAssignmentsListProps {
  roleAssignments: IManageUserDetail[],
  roleAssignmentService: AddRoleAssignmentService
}
const RoleAssignmentList: React.FC<IRoleAssignmentsListProps> = ({ roleAssignments, roleAssignmentService }) => {
  let roleAssignmentsDetail: React.ReactElement | undefined;
 
  if (roleAssignments
    && roleAssignments.length > 0) {
    roleAssignmentsDetail = (
      <>
        <div className="row header linkbutton">
          <div className="cell roles">
            Roles
          </div>
          <div className="cell">
            Group
          </div>
          <div className="cell">
            RC Editor
          </div>
          <div className="cell">
            Orgs/Plants
          </div>
          <div className="cell">
            Service Types
          </div>
          <div className="cell">
            Equipment
          </div>
          <div className="cell">
            Countries
          </div>
          <div className="cell">
            Epic Equipment
          </div>
          <div className="cell">
            Geo Units
          </div>
          <div className="cell">
            Product Centers
          </div>
          <div>
            Action
          </div>
        </div>
        <div className="flow-body">
          {roleAssignments
            && roleAssignments.length > 0
            && roleAssignments.map(a => (
              <div className="row hover-gray-bg" key={a.role.concat(a.isRCEditor.toString() + a.isTechUser.toString() + a.isPsdUser.toString() + a.isMfgUser.toString())} onClick={() => roleAssignmentService.onEditRoleAssignment(a)}>
                <div className="cell roles">
                  <span>{a.role}</span>
                </div>
                <div className="cell">
                  {a.isPsdUser &&
                      <span>
                      <UserGroupIcon
                          userGroup={UserGroups.PSD}
                      />
                    </span>
                  }
                  {a.isTechUser &&
                      <span>
                      <UserGroupIcon
                          userGroup={UserGroups.TLM}
                      />
                    </span>
                  }
                  {a.isMfgUser &&
                      <span>
                      <UserGroupIcon
                          userGroup={UserGroups.MFG}
                      />
                    </span>
                  }
                </div>

                <div className="cell">
                  <span>{a.isRCEditor ? "Yes" : "No"}</span>
                </div>

                <div className="cell">
                  <span>{a.orgs.map(x => x.code).join(", ")}</span>
                </div>

                <div className="cell">
                  <span>{a.serviceType.map(x => x.value).join(", ")}</span>
                </div>

                <div className="cell">
                  <span>{a.equipment.map(x => x.value).join(", ")}</span>
                </div>

                <div className="cell">
                  <span>{a.country.map(x => x.value).join(", ")}</span>
                </div>

                <div className="cell">
                  <span>{a.epicEquipment.map(x => x.value).join(", ")}</span>
                </div>

                <div className="cell">
                  <span>{a.geoUnit.map(x => x.value).join(", ")}</span>
                </div>

                <div className="cell">
                  <span>{a.productCenter.map(x => x.value).join(", ")}</span>
                </div>

                <div className="cell">
                  {a.role !== Roles.TechConRev && a.role !== Roles.SMEApprover &&
                      <img
                          src={DeleteIcon}
                          alt="Delete"
                          title="Delete"
                          className="icon-small"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            roleAssignmentService.onRemoveRoleAssignment(a);
                          }}
                      />
                  }
                </div>
              </div>))}
        </div>
      </>
    )
  }

  return (
  <>
    {roleAssignmentsDetail}
  </>);
}

export default RoleAssignmentList;